import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig, isMsalActive } from "@/config/auth";
import { App } from "./App";
// Initialise Application Insights as early as possible so that
// any errors thrown during bootstrap are also captured.
import "@/services/telemetry";
import "./locales/i18n";
import "./index.css";

const root = createRoot(document.getElementById("root")!);

if (isMsalActive) {
  const msalInstance = new PublicClientApplication(msalConfig);
  msalInstance.initialize().then(() => {
    msalInstance.handleRedirectPromise().catch(console.error);
    root.render(
      <MsalProvider instance={msalInstance}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MsalProvider>
    );
  });
} else {
  // Databricks Apps (or MSAL unconfigured): no MSAL instance/provider. Identity
  // comes from the proxy + backend /me; nothing here may call MSAL hooks.
  root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}
